import { isEmpty as _isEmpty } from "lodash";
import * as React from "react";
import AppUtils from "../../utils/AppUtils";
import CollapsibleCardView from "../CollapsibleCardView";
import PatientAdditionalInstructionsEditor from "../patient/edit/PatientAdditionalInstructionsEditor";
import PatientAllergyEditor from "../patient/edit/PatientAllergyEditor";
import { default as PatientConcernEditor } from "../patient/edit/PatientConcernEditor";
import PatientConditionsEditor from "../patient/edit/PatientConditionsEditor";
import PatientCurrentMedicationEditor from "../patient/edit/PatientCurrentMedicationEditor";
import PatientDiagnosticLabTestsEditor from "../patient/edit/PatientDiagnosticLabTestsEditor";
import PatientDietPlanEditor from "../patient/edit/PatientDietPlanEditor";
import PatientDietRecallEditor from "../patient/edit/PatientDietRecallEditor";
import PatientDifferentialDiagnosisEditor from "../patient/edit/PatientDifferentialDiagnosisEditor";
import PatientFitnessRecallEditor from "../patient/edit/PatientFitnessRecallEditor";
import PatientHabitEditorNew from "../patient/edit/PatientHabitEditorNew";
import PatientIllnessesEditor from "../patient/edit/PatientIllnessesEditor";
import PatientLabTestsEditor from "../patient/edit/PatientLabTestsEditor";
import { default as PatientLifeStyleEditor } from "../patient/edit/PatientLifeStyleEditor";
import PatientLifestyleHabitsEditor from "../patient/edit/PatientLifestyleHabitsEditor";
import PatientRedFlagsEditor from "../patient/edit/PatientRedFlagsEditor";
import PatientSurgeryEditor from "../patient/edit/PatientSurgeryEditor";
import PatientSymptomEditor from "../patient/edit/PatientSymptomEditor";
import PatientVitalsEditor from "../patient/edit/PatientVitalsEditor";
import PersonalInfoEditor from "../patient/edit/PersonalInfoEditor";
import PhysioComplaintsEditor from "../patient/edit/PhysioComplaintsEditor";
import PsychiatricHistoryEditor from "../patient/edit/PsychiatricHistoryEditor";
import TrackableSymptomsEditor from "../patient/edit/TrackableSymptomsEditor";
import PatientVitalsSummaryBar from "../patient/summary-bar/PatientVitalsSummaryBar";
import AdditionalInstructionsView from "../patient/view/AdditionalInstructionsView";
import HabitsPlanView from "../patient/view/HabitsPlanView";
import HealthTargetsView from "../patient/view/HealthTargetsView";
import LCGoalsView from "../patient/view/LCGoalsView";
import MindfulnessPlanView from "../patient/view/MindfulnessPlanView";
import PatientAllergyView from "../patient/view/PatientAllergyView";
import PatientConcernView from "../patient/view/PatientConcernView";
import PatientConditionsView from "../patient/view/PatientConditionView";
import PatientDiagnosisView from "../patient/view/PatientDiagnosisView";
import PatientLabTestsView, { default as PatientDiagnosticLabTestsView } from "../patient/view/PatientDiagnosticLabTestsView";
import PatientDietPlanView from "../patient/view/PatientDietPlanView";
import PatientFitnessPlansView from "../patient/view/PatientFitnessPlansView";
import PatientHabitView from "../patient/view/PatientHabitView";
import PatientIllnessView from "../patient/view/PatientIllnessView";
import PatientLifeStyleView from "../patient/view/PatientLifeStyleView";
import PatientPlanEligibilityView from "../patient/view/PatientPlanEligibilityView";
import PatientRedFlagsView from "../patient/view/PatientRedFlagsView";
import PatientSurgeryView from "../patient/view/PatientSurgeryView";
import PatientSymptomView from "../patient/view/PatientSymptomView";
import PatientVitalsView from "../patient/view/PatientVitalsView";
import PersonalInfoView from "../patient/view/PersonalInfoView";
import PhysioSymptomView from "../patient/view/PhysioSymptomView";
import MedicinePrescriptionView from "../prescription/medicine/MedicinePrescriptionView";
import HealthTargetsEdit from "../patient/edit/HealthTargetsEdit";
import OtherHealthTargetsEdit from "../patient/edit/OtherHealthTargetsEdit";
import MindfulnessInfoEditor from "../patient/edit/MindfulnessEditor";
import { LCGoalEditor } from "../patient/edit/LCGoalEditor";
import DetailsInfoEditor from "../patient/edit/DetailsInfoEditor";
import CaseSummaryEditor from "../patient/edit/CaseSummaryEditor";
import MindfulnessPlansEditor from "../patient/edit/MindfulnessPlanEditor";
import HabitPlansEditor from "../patient/edit/HabitsPlanEditor";
import FoodGroupsEditor from "../patient/edit/FoodGroupsEditor";
import GenericEditor from "../patient/edit/GenericEditor";
import LMPEditor from "../patient/edit/LMPEditor";
import PatientFitnessPlansEditor from "../patient/edit/FitnessPlanEditor";

/**
 * Created by abhinav on 28/01/18.
 */

let editViewComponentMap: { [s: string]: any } = {
    "todaysVitals": {
        "view": PatientVitalsSummaryBar,
        "edit": PatientVitalsEditor,
    },
    "vitals": {
        "view": PatientVitalsView,
        "edit": PatientVitalsEditor,
        "summary": PatientVitalsSummaryBar
    },
    "surgery": {
        "view": PatientSurgeryView,
        "edit": PatientSurgeryEditor
    },
    "allergy": {
        "view": PatientAllergyView,
        "edit": PatientAllergyEditor
    },
    "habit": {
        "view": PatientHabitView,
        "edit": PatientHabitEditorNew
    },
    "currentMedication": {
        "view": MedicinePrescriptionView,
        "edit": PatientCurrentMedicationEditor
    },
    "complaints": {
        "view": PatientSymptomView,
    },
    "physiocomplaints": {
        "view": PhysioSymptomView,
        "edit": PhysioComplaintsEditor
    },
    "illnesses": {
        "view": PatientIllnessView,
        "edit": PatientIllnessesEditor
    },
    "conditions": {
        "view": PatientConditionsView,
        "edit": PatientConditionsEditor
    },
    "symptom": {
        "view": PatientSymptomView,
        "edit": PatientSymptomEditor
    },
    "concern": {
        "view": PatientConcernView,
        "edit": PatientConcernEditor
    },
    "redFlags": {
        "view": PatientRedFlagsView,
        "edit": PatientRedFlagsEditor
    },
    "exams": {
        "view": PatientSymptomEditor,
    },
    "lifeStyle": {
        "view": PatientLifeStyleView,
        "edit": PatientLifeStyleEditor
    },
    "diagnosis": {
        "view": PatientDiagnosisView,
    },
    "differentialDiagnosis": {
        "view": PatientDiagnosisView,
        "edit": PatientDifferentialDiagnosisEditor
    },
    "labTest": {
        "view": PatientLabTestsView,
        "edit": PatientLabTestsEditor
    },
    "diagnosticLabtest": {
        "view": PatientDiagnosticLabTestsView,
        "edit": PatientDiagnosticLabTestsEditor
    },
    "additionalInstructions": {
        "view": AdditionalInstructionsView,
        "edit": PatientAdditionalInstructionsEditor
    },
    "healthTarget": {
        "view": HealthTargetsView,
        "edit": HealthTargetsEdit,
    },
    "otherHealthTarget": {
        "view": OtherHealthTargetsEdit,
        "edit": OtherHealthTargetsEdit
    },
    "personalInfo": {
        "view": PersonalInfoView,
        "edit": PersonalInfoEditor
    },
    "habits": {
        "view": PatientLifestyleHabitsEditor,
        "edit": PatientLifestyleHabitsEditor
    },
    // "dailyRoutine": {
    //     "view": DailyRoutineEditor,
    //     "edit": DailyRoutineEditor
    // },
    "mindfulness": {
        "view": MindfulnessInfoEditor,
        "edit": MindfulnessInfoEditor
    },
    "details": {
        "view": DetailsInfoEditor,
        "edit": DetailsInfoEditor
    },
    "psychiatric": {
        "view": PsychiatricHistoryEditor,
        "edit": PsychiatricHistoryEditor
    },
    "caseSummary": {
        "view": MindfulnessInfoEditor,
        "edit": CaseSummaryEditor
    },
    "fitnessPlan": {
        "view": PatientFitnessPlansView,
        "edit": PatientFitnessPlansEditor
    },
    "mindfulnessPlan": {
        "view": MindfulnessPlanView,
        "edit": MindfulnessPlansEditor
    },
    "habitsPlan": {
        "view": HabitsPlanView,
        "edit": HabitPlansEditor
    },
    "dietPlan": {
        "view": PatientDietPlanView,
        "edit": PatientDietPlanEditor
    },
    "mealOptions": {
        "view": MindfulnessInfoEditor,
        "edit": PatientDietPlanEditor
    },
    "dietRecall": {
        "view": PatientConcernView,
        "edit": PatientDietRecallEditor
    },
    "fitnessRecall": {
        "view": PatientFitnessRecallEditor,
        "edit": PatientFitnessRecallEditor
    },
    "foodGroups": {
        "view": MindfulnessInfoEditor,
        "edit": FoodGroupsEditor
    },
    "trackableSymptoms": {
        "view": TrackableSymptomsEditor,
        "edit": TrackableSymptomsEditor
    },
    "painHistory": {
        "view": GenericEditor,
        "edit": GenericEditor
    },
    "GenericEditor": {
        "view": GenericEditor,
        "edit": GenericEditor
    },
    "lmp": {
        "view": LMPEditor,
        "edit": LMPEditor
    },
    "userEligibility": {
        "view": PatientPlanEligibilityView,
        "edit": PatientPlanEligibilityView
    },
    "lcGoals": {
        "view": LCGoalsView,
        "edit": LCGoalEditor
    }
}

export enum EditViewDisplayMode {
    VIEW, EDIT, VIEW_EDIT
}

interface EditViewCardProps {
    cardTitleDisplay: string,
    templateName: string,
    templateProps: any,
    lastEditedEpoch: number,
    saveActionHandler: () => void,
    cancelActionHandler: () => void,
    displayMode?: EditViewDisplayMode,
    showSummary?: boolean,
    showCollapseButton?: boolean,
    collapseInEdit?: boolean,
    collapsedTextPlaceholderForMobile?: string | undefined
    actionButtonText?: { action: string, primaryAction: string},
}


interface EditViewCardState {
    isEditMode: boolean
}

class EditViewCard extends React.Component<EditViewCardProps, EditViewCardState> {

    constructor(props: EditViewCardProps) {
        super(props)
        this.state = this.getStateFromProps(props);
    }

    getStateFromProps(props: EditViewCardProps) {
        if (props.displayMode !== null && props.displayMode === EditViewDisplayMode.EDIT) {
            return {
                isEditMode: props.displayMode === EditViewDisplayMode.EDIT
            }
        } else {
            return {
                isEditMode: false
            }
        }
    }

    toggleEditMode = (editMode: boolean) => {
        this.setState({ isEditMode: editMode })
    }

    cancelActionHandler = () => {
        _isEmpty(this.props.actionButtonText) && this.toggleEditMode(false);
        this.props.cancelActionHandler();
    }

    handlePrimaryActionCallback = () => {
        this.props.saveActionHandler()
        _isEmpty(this.props.actionButtonText) && this.toggleEditMode(false)
    }

    render() {
        let EditComponent = editViewComponentMap[this.props.templateName]["edit"];
        let ViewComponent = editViewComponentMap[this.props.templateName]["view"];
        let viewComponentProps = this.props.templateProps["view"];
        let editComponentProps = this.props.templateProps["edit"];
        let formattedLastEditedDate = AppUtils.getFormattedLastEditedDate(this.props.lastEditedEpoch);
        let showActionButtons = (this.props.displayMode !== null && this.props.displayMode !== undefined ? false : true)
            || !_isEmpty(this.props.actionButtonText);
        let SummaryBar = this.props.showSummary ? editViewComponentMap[this.props.templateName]["summary"] : "";
        let showCollapseButton = this.props.showCollapseButton !== undefined ? this.props.showCollapseButton : true;
        let responseData = "";
        (this.props.templateProps && this.props.templateProps.edit) ?
            responseData = this.props.templateProps.edit.responseData : responseData = null;

        return (
            <div className="edit-view-card">
                {
                    !this.state.isEditMode &&
                    <div className="view-section">
                        <CollapsibleCardView showCollapseButton={showCollapseButton} titleComponent={this.props.cardTitleDisplay} actionName={"Edit"} actionCallback={() => this.toggleEditMode(true)} showActionButtons={showActionButtons} responseData={responseData} collapsedTextPlaceholderForMobile={
                    this.props.collapsedTextPlaceholderForMobile
                  }>
                            {
                                this.props.showSummary &&
                                <SummaryBar {...viewComponentProps} />
                            }
                            <ViewComponent {...viewComponentProps} />
                        </CollapsibleCardView>
                        <div className="last-edited-date">
                            {"Last edited on " + formattedLastEditedDate}
                        </div>
                    </div>
                }
                {
                    this.state.isEditMode &&
                    <div className="edit-section">
                        <CollapsibleCardView
                            titleComponent={this.props.cardTitleDisplay}
                            actionName={(this.props.actionButtonText ? this.props.actionButtonText.action : "Clear")}
                            actionCallback={this.cancelActionHandler}
                            primaryActionName={(this.props.actionButtonText ? this.props.actionButtonText.primaryAction : "Save")}
                            primaryActionCallback={this.handlePrimaryActionCallback}
                            showActionButtons={showActionButtons}
                            showCollapseButton={this.props.collapseInEdit}
                            responseData={responseData}
                            collapsedTextPlaceholderForMobile={
                                this.props.collapsedTextPlaceholderForMobile
                            }
                        >
                            <EditComponent {...editComponentProps} />
                        </CollapsibleCardView>
                    </div>
                }
            </div>
        );
    }
}

export default EditViewCard
